import axios from 'axios'

const SOW_PROCESS = {
  basic_status: {parent_is_edit: 1, level: 2, parent_id: 4006, business_type: 2, module: 1, is_edit: 1, is_finish: 1, is_disable: 0},
  evaluation_status: {parent_is_edit: 1, level: 2, parent_id: 4006, business_type: 2, module: 4, is_edit: 1, is_finish: 0, is_disable: 1},
  price_status: {parent_is_edit: 1, level: 2, parent_id: 4006, business_type: 2, module: 2, is_edit: 1, is_finish: 0, is_disable: 1},
  report_status: {parent_is_edit: 1, level: 2, parent_id: 4006, business_type: 2, module: 3, is_edit: 1, is_finish: 0, is_disable: 1}
}

const ECTABS = [
  {
    tab_name: 'tab_basic',
    action: '/ec-campaign/process/basic-info',
    is_open: true
  },
  {
    tab_name: 'tab_buying_brief',
    action: '/ec-campaign/process/buying-brief'
  },
  {
    tab_name: 'tab_io',
    action: '/ec-campaign/process/io-info'
  },
  {
    tab_name: 'tab_material',
    action: '/ec-campaign/process/material-info'
  },
  {
    tab_name: 'tab_user',
    action: '/ec-campaign/process/campaign-participant'
  }
  // {
  //   tab_name: 'tab_ec_audit',
  //   actions: 'ec-audit'
  // }
]

export default {
  namespaced: true,

  state: {
    id: null, // campaign id
    campaignName: '', // 当前活动名称
    phase: '', // 当前campaign所处阶段
    phaseType: null,
    activePhaseType: null,
    subFinalScopeId: null, // sub final scope id
    taskId: null, // 后端用的 task id
    taskName: '', // 后端用的 task name
    businessType: null, // 后端用的 business type
    businessKey: null, // 后端用的 business type
    originalBusinessType: null,
    deliverVendorId: null, // campaign_deliver_vendor_id
    subFinalScopeVendorId: null, // sub final scope 对应的vendor id
    isNewBrief: 0, // 是否新的 brief
    parentTaskAssignee: '', // 后端用的 parent_task_assignee
    contact: {
      IT: { mail: '' },
      market: { mail: '' },
      purchase: { mail: '' }
    },
    subFinalScopeInfo: null,
    editCampaignModulePermission: null,
    subFinalScopeList: [],
    showTaskHistory: false,
    isNewSubFinalScope: false, // 用来标记进入快捷版sub final scope的状态,f
    campaignSurvey: null,
    dotSubFinalScopeId: null,
    dotPhaseType: null,
    dotBusinessType: null,
    dotTaskIdInProgress: null,
    quotationExtendOrder: {},
    campaignListKeyword: '',
    campaignListPageNumber: 5,
    campaignListBrandId: null,
    campaignListVendorId: null,
    ecCampaignListChannel: null,
    ecCampaignListType: 1,
    sowProcess: SOW_PROCESS,
    campaignVersion: null,
    ecCampaignInfo: {},
    ECTab: null,
    ecCampaignListBrandCategoryId: null,
    ecCampaignListBrandId: null,
    ecCampaignListShopId: null,
    ecCampaignListStatus: null,
    isBypassCampaign: false
  },

  getters: {},

  actions: {
    async update ({ commit, state }, id) {
      commit('setId', id)
      const contact = await axios.get('/management/subfinal/getContactInfo', {
        params: { campaign_id: id }
      })
      commit('setContact', contact)
    },
    async updateSubFinalScopeInfo ({ commit, state }, id) {
      const res = await axios.get('/management/subfinalExpress/getSubFinalScope', {
        params: {
          sub_final_scope_id: state.subFinalScopeId
        }
      })
      commit('setSubFinalScopeInfo', res)
    },
    async updateECCampaignInfo ({ commit, state }, id) {
      const res = await axios.get('/management/ec/getCampaignOverview', {
        params: {
          campaign_id: state.id
        }
      })
      commit('setECCampaignInfo', res)
    },
    async updateCampaignSurvey ({ commit, state }, id) {
      const params = { campaign_id: state.id }
      if (state.phaseType > 4) params.phase_type = state.phaseType
      const res = await axios.get('/management/campaign/getCampaignOverview', { params })
      commit('setCampaignVersion', res.version)
      commit('setCampaignSurvey', res)
    },
    async updateSowProcess ({commit, state}, id) {
      let process = SOW_PROCESS
      if (state.subFinalScopeId != null) {
        const params = { sub_final_scope_id: state.subFinalScopeId }
        process = await axios.get('/management/subfinalExpress/getSowProcess', {params})
      }
      commit('setSowProcess', process)
    },
    async updateECTab ({ commit, state }) {
      if (state.subFinalScopeId != null) {
        const [res1] = await Promise.all([axios.get('/management/ec/getTabList', {
          params: {
            sub_final_scope_id: state.subFinalScopeId
          }
        })
        // , axios.get('/management/ec/getTaskProgress', {
        //   params: {
        //     sub_final_scope_id: state.subFinalScopeId
        //   }
        // })
        ])
        const arr = res1.filter(i => i.can_view)
        arr.push({
          tab_name: 'tab_user',
          action: '/ec-campaign/process/campaign-participant',
          version: 'v1'
        })
        // console.log('res2', res2)
        commit('setECTab', arr)
        // commit('setECProcess', res2)
      } else {
        ECTABS.map(i => {
          if (i.name !== '基础信息') i.disabled = true
          return i
        })
        commit('setECTab', ECTABS)
      }
    }
  },

  mutations: {
    setId (state, id) {
      state.id = id
    },
    setCampaignName (state, name) {
      state.campaignName = name
    },
    setPhaseType (state, phaseType) {
      state.phaseType = phaseType
    },
    setActivePhaseType (state, activePhaseType) {
      state.activePhaseType = activePhaseType
    },
    setSubFinalScopeId (state, id) {
      state.subFinalScopeId = id
    },
    setDotSubFinalScopeId (state, id) {
      state.dotSubFinalScopeId = id
    },
    setDotPhaseType (state, id) {
      state.dotPhaseType = id
    },
    setDotBusinessType (state, id) {
      state.dotBusinessType = id
    },
    setDotTaskIdInProgress (state, id) {
      state.dotTaskIdInProgress = id
    },
    setTaskId (state, id) {
      state.taskId = id
    },
    setDeliverVendorId (state, id) {
      state.deliverVendorId = id
    },
    setSubFinalScopeVendorId (state, id) {
      state.subFinalScopeVendorId = id
    },
    setBusinessType (state, key) {
      state.businessType = key
    },
    setBusinessKey (state, key) {
      state.businessKey = key
    },
    setOriginalBusinessType (state, key) {
      state.originalBusinessType = key
    },
    setIsNewBrief (state, value) {
      state.isNewBrief = value
    },
    setTaskName (state, value) {
      state.taskName = value
    },
    setParentTaskAssignee (state, value) {
      state.parentTaskAssignee = value
    },
    setContact (state, contact) {
      state.contact = contact
    },
    setSubFinalScopeInfo (state, value) {
      state.subFinalScopeInfo = value
    },
    setEditCampaignModulePermission (state, value) {
      state.editCampaignModulePermission = value
    },
    setSubFinalScopeList (state, value) {
      state.subFinalScopeList = value
    },
    setShowTaskHistory (state, value) {
      state.showTaskHistory = value
    },
    setIsNewSubFinalScope (state, value) {
      state.isNewSubFinalScope = value
    },
    setCampaignSurvey (state, value) {
      state.campaignSurvey = value
    },
    setCampaignVersion (state, version) {
      state.campaignVersion = version
    },
    setQuotationExtendOrder (state, value) {
      state.quotationExtendOrder = value
    },
    setCampaignListKeyword (state, value) {
      state.campaignListKeyword = value
    },
    setCampaignListPageNumber (state, value) {
      state.campaignListPageNumber = value
    },
    setSowProcess (state, value) {
      state.sowProcess = value
    },
    setCampaignListVendorId (state, value) {
      state.campaignListVendorId = value
    },
    setCampaignListBrandId (state, value) {
      state.campaignListBrandId = value
    },
    setCampaignListStatus (state, value) {
      state.campaignListStatus = value
    },
    setECCampaignListChannel (state, value) {
      state.ecCampaignListChannel = value
    },
    setECCampaignListType (state, value) {
      state.ecCampaignListType = value
    },
    setECTab (state, value) {
      state.ECTab = value
    },
    setECProcess (state, value) {
      state.ECProcess = value
    },
    setECCampaignInfo (state, value) {
      state.ecCampaignInfo = value
    },
    setECCampaignListShopId (state, value) {
      state.ecCampaignListShopId = value
    },
    setECCampaignListBrandCategoryId (state, value) {
      state.ecCampaignListBrandCategoryId = value
    },
    setECCampaignListBrandId (state, value) {
      state.ecCampaignListBrandId = value
    },
    setECCampaignListStatus (state, value) {
      state.ecCampaignListStatus = value
    },
    setIsBypassCampaign (state, value) {
      state.isBypassCampaign = value
    }

  }
}
